//NPM LIBRARIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AUfieldset, AUlegend } from '@gov.au/form';
import AUtextInput from '@gov.au/text-inputs';
import { AUlabel, AUformGroup } from '@gov.au/form';
//COMPONENTS AND UTILITIES
import { validateAnswerHasValue } from '../../CASAForm/Utilities';

const timeRegexPattern = new RegExp("^[0-9]{0,2}$")

class TimeInputFields extends Component {

    constructor(props) {
        super(props);

        let answer = {
            value: '',
            subAnswers: {
                hourValue: '',
                minuteValue: ''
            }
        };
        let errorMessage = ''

        if (props.existingAnswer) {
            answer = props.existingAnswer

        } else if (props.initvalue) {
            let initialValue = props.initvalue.split(":");
            answer.subAnswers.hourValue = initialValue[0];
            answer.subAnswers.minuteValue = initialValue[1];
        }

        if (props.mandatory) {
            errorMessage = validateAnswerHasValue(props.type, answer, props.mandatory);
        }

        this.state = {
            answer: answer,
            errorMessage: errorMessage
        }
    }

    onBlur = (e) => {
        let errorMessage = validateAnswerHasValue(this.props.type, this.state.answer, this.props.mandatory);
        let answer = {
            value: this.state.answer.subAnswers.hourValue + ':' + this.state.answer.subAnswers.minuteValue,
            subAnswers: {
                hourValue: this.state.answer.subAnswers.hourValue,
                minuteValue: this.state.answer.subAnswers.minuteValue
            }
        }

        if (this.props.mandatory) {
            if (this.state.answer.subAnswers.hourValue && this.state.answer.subAnswers.minuteValue) {
                errorMessage = this.validateTime();
            }
        }

        this.setState({errorMessage: errorMessage});

        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            validate: this.props.validate,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: answer
        }

        this.props.returnQuestionData(questionObject);
    };

    onChangeHour = (e) => {
        if (!timeRegexPattern.test(e.target.value)) {
            return
        }
        this.setState({
            answer: {
                subAnswers: {
                    ...this.state.answer.subAnswers,
                    hourValue: e.target.value,
                }
            }
        })
    }

    onChangeMinute = (e) => {
        if (!timeRegexPattern.test(e.target.value)) {
            return
        }
        this.setState({
            answer: {
                subAnswers: {
                    ...this.state.answer.subAnswers,
                    minuteValue: e.target.value,
                }
            }
        })
    }

    validateTime = () => {
        let errorMessage = '';

        if (this.state.answer.subAnswers.hourValue > 24 || this.state.answer.subAnswers.hourValue < 0) {
            errorMessage = "Invalid time";
        } else if (this.state.answer.subAnswers.minuteValue > 59 || this.state.answer.subAnswers.minuteValue < 0) {
            errorMessage = "Invalid time";
        }
        return errorMessage;
    };

    render() {
        return (
            <div className="au-form-group casa-inline-form-group">
                <AUfieldset>

                    <AUlegend>
                        <h3 className="au-display-sm">{this.props.label}</h3>
                        <span className="au-hint-text">{this.props.hintText}</span>
                    </AUlegend>

                    <AUformGroup
                        className="sub-question-group"
                        status={this.props.getStatus(this.state.errorMessage)}>

                        <div className="sub-question-group">
                            <AUformGroup
                                className="casa-inline-form-subgroup"
                                status={this.props.getStatus(this.state.errorMessage)}>

                                <AUlabel text="Hour" htmlFor={`HH${this.props.id}`} />
                                <AUtextInput
                                    id={`Hour${this.props.id}`}
                                    type="text"
                                    name={this.props.id}
                                    block
                                    onChange={this.onChangeHour}
                                    onBlur={this.onBlur}
                                    placeholder="HH"
                                    value={this.state.answer.subAnswers.hourValue}
                                    aria-describedby={`${this.props.id}-error`}
                                    status={this.props.getStatus(this.state.errorMessage)}
                                />

                            </AUformGroup>

                            <AUformGroup
                                className="casa-inline-form-subgroup"
                                status={this.props.getStatus(this.state.errorMessage)}>

                                <AUlabel text="Minutes" htmlFor={`MM${this.props.id}`} />
                                <AUtextInput
                                    id={`Minute${this.props.id}`}
                                    type="text"
                                    name={this.props.id}
                                    block
                                    onChange={this.onChangeMinute}
                                    onBlur={this.onBlur}
                                    placeholder="MM"
                                    value={this.state.answer.subAnswers.minuteValue}
                                    aria-describedby={`${this.props.id}-error`}
                                    status={this.props.getStatus(this.state.errorMessage)}
                                />

                            </AUformGroup>
                        </div>
                        {this.props.createErrorMessage(this.state.errorMessage)}
                    </AUformGroup>

                </AUfieldset>
            </div>
        );
    }
}

TimeInputFields.propTypes = {
    id: PropTypes.string.isRequired,
    stepid: PropTypes.string.isRequired,
    initvalue: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    hintText: PropTypes.string,
    mandatory: PropTypes.bool,
    existingAnswer: PropTypes.object,
    validate: PropTypes.string,
    show: PropTypes.bool,
    getStatus: PropTypes.func,
    createErrorMessage: PropTypes.func,
    returnQuestionData: PropTypes.func
};

export default TimeInputFields;